package com.exura.features.userprofile.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("profile_organization")
data class OrganizationProfileDto(
    val email: String,
    val name: String?,
    val field: String?,
    val patientsContactNumber: String?,
) : UserSettingsBaseDto
